<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <!-- page Title -->
      <i-card-vertical headerTitle="위험성평가 이행" :IsUseEditorBox="true" device="web">
        <template v-slot:EditorBox>
          <!-- 날짜선택 -->
          <date-bar ref="year" :firstDisplayDate="startDate" :dateOnly="true" label="조회년도" year full-width @getDate="searchYearChanged" />
        </template>
        <template v-slot:body>
          <v-sheet class="tab-layout" v-if="tabList">
            <v-sheet class="tab-left twoSelect">
              <v-row no-gutters class="align-center">
                <v-col v-if="riskAssessmentList" cols="12" class="pl-2">
                  <v-select
                    :value="searchRiskAssessment"
                    :menu-props="{ offsetY: true }"
                    :items="riskAssessmentList"
                    item-text="riskAssessmentNm"
                    item-value="assessmentKey"
                    class="search-select editor_bg"
                    placeholder="위험성평가명"
                    label="위험성평가명"
                    @change="handleSelectChange"
                  ></v-select>
                </v-col>
                <v-col v-if="tabList" cols="12" class="pl-2">
                  <v-select
                    :value="searchRiskProcess"
                    :menu-props="{ offsetY: true }"
                    :items="tabList"
                    item-text="processNm"
                    item-value="assessmentKey"
                    class="search-select editor_bg"
                    placeholder="공정명"
                    label="공정명"
                    @change="handleProcessChange"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- 좌측 tab -->
              <v-card v-if="detailList" color="inner_card_bg" class="overflow-y-auto">
                <v-list class="pa-0 contents-menu">
                  <v-list-item-group>
                    <v-list-item
                      v-for="(item, index) in detailList"
                      :key="item.index"
                      @click="handleTabClick(index)"
                      :class="{ active: selectedKey === index }"
                    >
                      <v-list-item-content>
                        {{ item.workNm }}
                        <div class="sub-text">
                          감소대책 수 : {{ item.count ? item.count : '-' }}
                          <span class="text-divider">|</span>
                          이행 :
                          {{ item.cnt ? item.cnt : '-' }} / 미이행 :
                          {{ item.uncnt ? item.uncnt : '-' }}
                        </div>
                        <!-- <div class="sub-text">이행 :{{ item.cnt }} 미이행 :{{ item.uncnt }}</div> -->
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-sheet>
            <!-- 우측 테이블 영역 -->
            <v-card class="overflow-y-auto" :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <implementationPanelTree
                v-show="selectedKey === selectedKey"
                ref="implementationPanelTree"
                class="custom-panel"
                :datasource="datasource"
                :dataSetList="dataSetList"
                :assessmentKey="titlePanel"
                :deleteFileList="deleteFileList"
                @initializedImplementation="initializedImplementation"
                @titleClick="titleClick"
              />
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00002'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          class="d-md-flex"
          :useBtnList="buttonUseList"
          @btnSearch="btnSearch(true)"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        ></i-card-right>

        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import notify from 'devextreme/ui/notify'
import { AesDecrypt } from '@/utils/aes256'

import dateBar from '@/components/common/dateBar.vue'
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import implementationPanelTree from './components/ImplementationPanelTree'
import { getCurrentDate } from '@/utils/common.js'
import { getPreMonth, getYearFormat } from '@/utils/common.js'
//위험성평가명
import {
  saveRiskAssessmentImentation,
  getRiskAssessmentImplementationReport,
  initializedImplementation
} from '@/api/riskAssessment/riskAssessmentImplementation.js'
import { getRiskAssessments } from '@/api/riskAssessment/riskAssessmentProcess.js'
//위험성평가 작업내용
import { getRiskAssessmentCreationList } from '@/api/riskAssessment/riskAssessmentCreation.js'
//위험성평가 세부내용
import { getRiskAssessmentMeasuresReductionList } from '@/api/riskAssessment/riskAssessmentMeasuresReduction.js'
//공통코드
import { getCommonCode } from '@/api/common/commonApi'
import { getFile } from '@/api/baseManage/fileUpload'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    implementationPanelTree,
    'date-bar': dateBar,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      param: '',
      initCompId: '',
      buttonUseList: [
        'btnSearch', //조회
        'btnSave',
        'btnPrint'
      ],
      selectedKey: 0,
      tabList: [],
      riskAssessmentList: [],
      searchRiskAssessment: '',
      searchRiskProcess: '',
      test: 0,
      routeData: '',
      dataBefore: [],
      datasource: [],
      expandedPanel: '',
      //타이틀
      userSubject: [],

      //캘린더
      menuStDate: false,
      menuEdDate: false,
      editingData: {},
      //파라미터
      panelData: '',
      titlePanel: 0,
      deleteFileList: [],
      // 넘겨줄데이터
      dataSetList: [
        {
          riskFactorList: [],
          victimList: [],
          riskEstimation: '00001',
          riskEstimationList: [],
          riskEstimationSetting: [],
          infoBtnList: [],
          freqValueList: [],
          freqList: [],
          strengthList: [],
          deleteList: [],
          riskInit: {}
        }
      ],
      allTabList: [],
      detailList: [],
      startDate: getPreMonth(0),
      searchStartDate: getYearFormat(getPreMonth(0)),
      searchYear: '',
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  watch: {},
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    let param = {
      clntId: this.getClntId(),
      compId: this.initCompId,
      writeYear: this.searchStartDate
    }
    this.setComboBox(param)
  },
  activated() {
    // 페이지 이동시
    if (this.$route.params.data) {
      // 추가, 다른 데이터 상세 정보 호출 시
      //추가
      if (!this.$route.params.data.__created__) {
        // 페이지 이동 시, 다른 페이지에서 상세정보 조회 시
        let [constructId, processId] = this.$route.params.searchRiskProcess.split('_')
        let param = {
          clntId: this.getClntId(),
          compId: this.$route.params.data.compId,
          writeYear: getYearFormat(this.$route.params.data.writeDt),
          constructId: constructId,
          processId: processId
        }
        this.setComboBox(param)
      }
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      // 데이터 공간 초기화
      this.allTabList = []
      this.tabList = []
      this.detailList = []
      this.datasource = []
      this.param = ''
      this.initCompId = this.getCompId()
      let param = {
        clntId: this.getClntId(),
        compId: this.initCompId,
        writeYear: this.searchStartDate
      }
      this.setComboBox(param)
    }
  },
  beforeMount() {
    Promise.all([
      getCommonCode('RA004') /*위험분류 */,
      getCommonCode('RA005') /*위험성평가 사고발생시 피해예상자 */,
      getCommonCode('RA002') /*위험성 추정*/,
      getCommonCode('RA002_1'),
      getCommonCode('RA002_2'),
      getCommonCode('RA002_3')
    ])
      .then(response => {
        this.dataSetList[0].riskFactorList = response[0].list
        this.dataSetList[0].victimList = response[1].list
        this.dataSetList[0].riskEstimationList = response[2].list
        this.dataSetList[0].riskEstimation = response[2].list[0].minorCd
        this.dataSetList[0].riskEstimationList.forEach(el => {
          this.dataSetList[0].riskEstimationSetting[el.minorCd] = { minorNm: el.minorNm, minorCd: el.minorCd, data: [] }
        })
        this.dataSetList[0].riskEstimationValue = response[3].list
        response[3].list.forEach(el => {
          if (this.dataSetList[0].riskEstimationSetting[el.extra1]?.data) {
            this.dataSetList[0].riskEstimationSetting[el.extra1].data.push({ minorNm: el.minorNm, minorCd: el.minorCd, extra: el.extra2 })
          }
        })
        this.dataSetList[0].infoBtnList = response[4].list
        this.dataSetList[0].freqValueList = response[5].list
      })
      .finally(() => {
        if (Object.keys(this.dataSetList[0].riskEstimationSetting).length > 0) {
          this.dataSetList[0].freqList = this.dataSetList[0].riskEstimationSetting['00001'].data
            .filter(el => el.extra == 'frequency')
            .sort((a, b) => a.minorNm.localeCompare(b.minorNm))
          this.dataSetList[0].strengthList = this.dataSetList[0].riskEstimationSetting['00001'].data
            .filter(el => el.extra == 'strength')
            .sort((a, b) => a.minorNm.localeCompare(b.minorNm))
        }
      })
  },
  mounted() {},
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name
    }
  },
  methods: {
    // 1.년도 조회
    searchYearChanged(year) {
      this.searchStartDate = String(year)
      let param = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeYear: this.searchStartDate
      }
      this.tabList = []
      this.detailList = []
      this.datasource = []
      this.setComboBox(param)
    },
    // 2.위험성평가명 조회
    setComboBox(param) {
      Promise.all([getRiskAssessments(param, false)]).then(response => {
        this.riskAssessmentList = response[0].list
        if (this.riskAssessmentList.length > 0) {
          if (this.$route.params.data && !this.$route.params.data.__created__) {
            this.param = this.$route.params.data
            this.searchRiskAssessment = this.$route.params.searchRiskAssessment
            this.selectedKey = this.$route.params.selectedKey
            ;(this.param.__riskFactor__ = true), (this.param.__reduce__ = true)
          } else {
            this.searchRiskAssessment = this.riskAssessmentList[0].assessmentKey
            const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
            this.param = {
              clntId: clntId,
              compId: compId,
              writeDt: writeDt,
              docNo: docNo,
              __riskFactor__: true,
              __reduce__: true
            }
          }
          this.btnSearch(true)
        }
      })
    },

    // 위험성명 select
    handleSelectChange(value) {
      this.detailList = []
      this.searchRiskAssessment = value
      //재검색
      const [clntId, compId, writeDt, docNo] = this.searchRiskAssessment.split('_')
      this.param = {
        clntId: clntId,
        compId: compId,
        writeDt: writeDt,
        docNo: docNo,
        __riskFactor__: true,
        __reduce__: true
      }
      this.btnSearch(true)
    },
    // 3.공정명 조회
    async btnSearch(isNotify) {
      console.log('############################# ', this.param)
      if (this.param) {
        this.openLoading('searching')
        getRiskAssessmentCreationList(this.param, isNotify)
          .then(response => {
            if (response.success) {
              //tabList에 공정명 넣기
              this.tabList = response.list
              if (this.tabList.length > 0) {
                // 공정명 1번째 값으로 초기세팅
                if (this.$route.params.data && !this.$route.params.data.__created__) {
                  this.searchRiskProcess = this.$route.params.searchRiskProcess
                } else this.searchRiskProcess = this.tabList[0].constructId + '_' + this.tabList[0].processId
              }
            }
          })
          .finally(() => {
            this.endLoading()
            this.riskTypeSetting()
            this.detailSearch(this.searchRiskProcess)
          })
      }
    },
    riskTypeSetting() {
      // 개설에서 빈도강도 or 수준3단계 default 값 가져오기
      this.dataSetList[0].riskInit = this.riskAssessmentList.find(el => el.assessmentKey === this.searchRiskAssessment)
      if (this.dataSetList[0].riskInit) {
        let riskType = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == this.dataSetList[0].riskInit.riskEstimationVal1)
        if (riskType) {
          this.dataSetList[0].riskEstimation = riskType.extra1
        }
      }
    },
    // 공정명 select
    handleProcessChange(value) {
      this.selectedKey = 0
      this.searchRiskProcess = value
      this.detailSearch(value)
    },
    // 4. 공정리스트 조회
    detailSearch(value) {
      this.datasource = []
      const [constructId, processId] = this.searchRiskProcess.split('_')
      let param = {
        clntId: this.param.clntId,
        compId: this.param.compId,
        writeDt: this.param.writeDt,
        docNo: this.param.docNo,
        constructId: constructId,
        processId: processId,
        __riskFactor__: true,
        __reduce__: true
      }
      // 재검색 하여 좌측 tab 데이터 넣기
      getRiskAssessmentCreationList(param, false)
        .then(response => {
          if (response.success) {
            this.allTabList = response.list
          }
        })
        .finally(() => {
          const foundTab = this.allTabList.find(el => el.assessmentKey === this.searchRiskProcess)
          if (foundTab) {
            foundTab.works.forEach(item => {
              let count = 0
              let cnt = 0
              let uncnt = 0
              if (item.factor.length > 0) {
                //작업 내용이 있는
                item.factor.forEach(item => {
                  if (item.reduction.length > 0) {
                    item.reduction.forEach(el => {
                      if (!el.actDt || !el.esgHrNo) {
                        uncnt++
                      } else cnt++
                      //감소대책 갯수
                      count++
                    })
                  }
                })
              }
              //감소대책 갯수 할당
              item.count = count
              item.cnt = cnt
              item.uncnt = uncnt
            })
            this.detailList = foundTab.works
            if (!this.selectedKey) {
              //선택된 패널 없으면
              let panelIdx = 0
              this.handleTabClick(panelIdx)
            } else this.handleTabClick(this.selectedKey)
          }
        })
    },
    // 5. 작업별 위험성평가 조회
    handleTabClick(index) {
      if (!index) {
        this.selectedKey = 0
      }
      this.selectedKey = index
      let data = this.detailList[this.selectedKey]

      let param = {
        clntId: data.clntId,
        compId: data.compId,
        writeDt: data.writeDt,
        docNo: data.docNo,
        constructId: data.constructId,
        processId: data.processId,
        workId: data.workId
      }
      getRiskAssessmentMeasuresReductionList(param, false)
        .then(response => {
          if (response.success) {
            response.list.forEach(item => {
              let cnt = 0
              let uncnt = 0
              if (item.reduction.length > 0) {
                item.reduction.forEach(el => {
                  if (!el.actDt || !el.esgHrNo) {
                    uncnt++
                  } else cnt++
                  if (el.code) {
                    let imgParams = []
                    el.code.forEach(el => {
                      if (!el.target) {
                        let params = {
                          clntId: this.getClntId(),
                          targetType: '00017',
                          targetId: el.extra1
                        }
                        imgParams.push(params)
                      }
                    })
                  }
                })
              }
              item.cnt = cnt
              item.uncnt = uncnt
            })
            this.datasource = []
            response.list.forEach(el => {
              if (el.reduction.length > 0) {
                this.datasource.push(el)
              }
            })
          }
        })
        .finally(() => {
          this.riskValueSetting()
          this.imgCellSearch()
        })

      // this.titlePanel = 0
    },
    riskValueSetting() {
      //위험성 수준 값이 없을 때 초기 값 개설에서 가져와서 보여주기

      if (this.datasource.length > 0) {
        this.datasource.forEach(item => {
          if (!item.riskEstimationVal1) {
            item.riskEstimationVal1 = this.dataSetList[0].riskInit.riskEstimationVal1
            item.riskEstimationNum1 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == item.riskEstimationVal1).extra3
            item.riskEstimationAfterVal1 = item.riskEstimationVal1
            item.riskEstimationAfterNum1 = item.riskEstimationNum1

            if (this.dataSetList[0].riskEstimation == '00001') {
              //빈도강도법일때는 val2도 넣어주기
              item.riskEstimationVal2 = this.dataSetList[0].riskInit.riskEstimationVal2
              item.riskEstimationNum2 = this.dataSetList[0].riskEstimationValue.find(el => el.minorCd == item.riskEstimationVal2).extra3
              item.riskEstimationAfterVal2 = item.riskEstimationVal2
              item.riskEstimationAfterNum2 = item.riskEstimationNum2
            }
          }
        })
      }
    },
    imgCellSearch() {
      if (this.$refs.implementationPanelTree.$refs.imgCellFileManage) {
        this.$refs.implementationPanelTree.$refs.imgCellFileManage.forEach(el => {
          el.btnSearch()
        })
      }
    },
    titleClick(index) {
      this.titlePanel = index
    },
    btnSave() {
      for (const item of this.datasource) {
        let list = item.reduction.filter(element => element.__updated__)
        /*
        if (list.length == 0) {
          this.vToastify(this.$t('수정된 데이터가 존재하지 않습니다.'), 'warn')
          return
        }
        */
        if (list.some(el => !el.esgHrNo)) {
          this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
          return
        }
      }

      this.vToastifyPrompt(this.$t('저장하시겠습니까?'), 'info', async current => {
        this.openLoading()
        let saveData = []
        this.datasource.forEach(el => {
          el.reduction.forEach(el => {
            if (el.__updated__) saveData.push(el)
          })
        })
        let saveFileList = []
        this.$refs.implementationPanelTree.$refs.imgCellFileManage.forEach(el => {
          // 이미지 셀 컴포넌트를 순회하면서 저장된 이미지 파일 정보 호출
          if (Object.keys(el.newFile).length > 0) saveFileList.push(el.newFile)
        })
        saveRiskAssessmentImentation(saveData, true)
          .then(res => {
            if (this.deleteFileList.length > 0) {
              this.deleteFileList.forEach(el => {
                el.clntId = this.getClntId()
              })
              this.$refs.implementationPanelTree.$refs.imgCellFileManage[0].btnDelete(this.deleteFileList) // 셀에 저장된 이미지 삭제
            }
            this.$refs.implementationPanelTree.$refs.imgCellFileManage[0].btnSave(saveFileList)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
            // this.btnSearch(true)
            this.deleteFileList = []
          })
      })
    },
    btnPrint(type) {
      let data = this.detailList[this.selectedKey]
      if (!data) {
        this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
        return
      }
      let params = {
        clntId: data.clntId,
        compId: data.compId,
        writeDt: data.writeDt,
        docNo: data.docNo,
        constructId: data.constructId,
        processId: data.processId,
        workId: data.workId,
        type: type
      }
      this.openLoading()
      getRiskAssessmentImplementationReport(params)
        .then(res => {
          this.downloadReport(res)
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async initializedImplementation(item) {
      this.vToastifyPrompt(this.$t(`[${item.riskReduceMeasuresContent}]<br/>이행 정보를 초기화하시겠습니까?`), 'info', async current => {
        this.openLoading('deleting')
        try {
          const response = await initializedImplementation(item, true)
          if (response.success) {
            this.btnSearch(false)
          }
        } catch (error) {
        } finally {
          this.endLoading()
        }
      })
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    downloadReport(res) {
      let link = document.createElement('a')
      // 객체를 만들어서 생성
      let objectUrl = window.URL.createObjectURL(res.data)
      link.href = objectUrl
      link.download = res.headers.filename
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped></style>
